export default __webpack_public_path__ + "static/slide05-26a21c474877366d3376e85f20f4c64d.png";